module.exports = __webpack_public_path__ + "static/media/sawater.e856fe51.png";